import React from 'react';
import { useEffect } from "react";
import { useSelector, connect } from 'react-redux';
import { changeStepForm, changeTypeRedirect, STEPS, TIPO_VEHICULOS } from '../../redux/actions/PasosFormulario';
import { addReservacion } from '../../redux/actions/Reservacion';
import FormReservacion from './FormReservacion';
import FormConfirmacionVehiculo from './FormConfirmacionVehiculo';
import PanelReservacion from './PanelReservacion';
import FinalPedido from './FinalPedido';
import Summary from './Summary';
import Carousel from '../utils/Carousel';
import TrackingBar from '../utils/TrackingBar';
import Footer from '../utils/Footer';
import { isLoading } from '../../redux/actions/Loading';
import { Redirect } from "react-router-dom";


const EscogeTuVehiculo = ({ stepFoward, setReservacion, disabledRedirect }) => {



    //const { stepPrev , stepActive} = useSelector(state => state.pasosReservacion);
    const { stepForm, typeCar, redirect, stepWay,stepActive,stepPrev } = useSelector(state => state.pasosReservacion);
    const sucursales = useSelector(state => state.sucursales);

    

    console.log(" >>>>>>>>>>> escoje tu vehiculo step ESTADO:" + stepForm);
    console.log(" type WAY: " + stepWay);
    console.log(" type car: " + typeCar);
    console.log(" >>>>>>>>>>> redirect : " + redirect);
    console.log(" >>>>>>>>>>> stepPrev : " + stepPrev);
    console.log(" ************* stepActive " + stepActive);     
    console.log(stepActive);

    useEffect(() => {

        if (redirect) {
            //console.log("****************** ejecutar redirect false **************** ")
            disabledRedirect(false);
        }

    }, [typeCar, redirect, stepForm]);

    const submitReservacion = ({ LugarRecepcion, LugarDevolucion, FechaRecepcion, FechaDevolucion }) => {
        //console.log("submitReservacion");
        let fechaRecepcion = new Date(FechaRecepcion);
        let fechaDevolucion = new Date(FechaDevolucion);

        setReservacion({
            LugarRecepcion: sucursales.find(w => w.Id === LugarRecepcion),
            LugarDevolucion: sucursales.find(w => w.Id === LugarDevolucion),
            FechaRecepcion,
            FechaDevolucion,
            Dias: Math.ceil((fechaDevolucion.getTime() - fechaRecepcion.getTime()) / (1000 * 60 * 60 * 24))
        });

        stepFoward();

    }

    if (stepForm === STEPS.FINAL && redirect === true) {
        return (<Redirect to="/graciasreserva" />)
    }
    

    if (stepForm === STEPS.RESERVACION ) {
        //console.log(" escoge tu vehiculo reservacion " + stepForm + " REGRESO AL INICIO ");
        return (<Redirect to="/" />)
    }

    if (stepForm === STEPS.COBERTURAS && redirect === true) {
        return (<Redirect to="/coberturasyserviciosadicionales" />)
    }
    if (stepForm === STEPS.CONFIRMACION && redirect === true) {
        return (<Redirect to="/confirmacion" />)
    }  

    if (stepForm === STEPS.DATOS_CLIENTE && redirect === true) {
        return (<Redirect to="/informarciondelcliente" />)
    }

    
    if (stepForm === STEPS.COTIZAR && redirect === true) {
        return (<Redirect to="/informarciondelcliente" />)
    }

    if (stepForm === STEPS.VEHICULO) {

        if (typeCar === TIPO_VEHICULOS.TIPO_SUV && redirect === true) {
            return (<Redirect to="/escogetuvehiculo/suv" />)
        }

        if (typeCar === TIPO_VEHICULOS.TIPO_PICKUP && redirect === true) {
            return (<Redirect to="/escogetuvehiculo/pickup" />)
        }

        if (typeCar === TIPO_VEHICULOS.TIPO_SEDAN && redirect === true) {
            return (<Redirect to="/escogetuvehiculo/sedan" />)
        }

        if (typeCar === TIPO_VEHICULOS.TIPO_VAN && redirect === true) {
            return (<Redirect to="/escogetuvehiculo/van" />)
        }

        if (typeCar === TIPO_VEHICULOS.TIPO_MINIVAN && redirect === true) {
            return (<Redirect to="/escogetuvehiculo/minivan" />)
        }
    }


    //console.log(" escoje tu vehiculo stepForm : " + stepForm);
    if (STEPS.RESERVACION !== stepForm && STEPS.FINAL !== stepForm) {
        console.log(" post escoje tu vehiculo stepform " + stepForm);
        return (
            <>
                <TrackingBar />
                <div className="container-form">
                    <div className="row">
                        {
                            (stepForm === STEPS.CONFIRMACION) &&
                            <div className={`confirmacion-movil ${(stepForm === STEPS.CONFIRMACION) ? "col-sm-4" : "col-sm-3"}`}>
                                <FormConfirmacionVehiculo />
                            </div>
                        }
                        <div className={(stepForm === STEPS.CONFIRMACION) ? "col-sm-7" : "col-sm-8"}>
                            <PanelReservacion step={stepForm} />
                        </div>
                        {(stepForm !== STEPS.CONFIRMACION) && <div className="col-sm-1"></div>}
                        <div className={`confirmacion-web ${(stepForm === STEPS.CONFIRMACION) ? "col-sm-4" : "col-sm-3"}`}>
                            {(stepForm === STEPS.CONFIRMACION) ? <FormConfirmacionVehiculo /> : <Summary />}
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    } else {
        if (STEPS.FINAL === stepForm) {
            return <FinalPedido />
        } else {
            return <>
                <Carousel />
                <FormReservacion onSubmit={submitReservacion} />
            </>
        }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        stepFoward: () => {
            //console.log("********** escoje tu vehiculo stepForward reservacionjs");
            dispatch(changeStepForm({ stepForm: STEPS.VEHICULO }));
            window.scrollTo(0, 0);

        },
        setReservacion: value => dispatch(addReservacion(value)),
        disabledRedirect: (booleanRedirect) => {
            //console.log(" Ejecutar false redirect");
            //console.log(booleanRedirect);
            dispatch(changeTypeRedirect(booleanRedirect));
        },
        isLoading: value => dispatch(isLoading(value))
    }
}

export default connect(null, mapDispatchToProps)(EscogeTuVehiculo);